import React, { useContext } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";
import { WithdrawalContext } from "@state/context/payment/WithdrawalContext";

export default observer(function WithdrawalTransactionStatusFilterSection() {
	const { t } = useTranslation("payment");
	const { register } = useFormContext();
	const { transactionStatuses } = useContext(WithdrawalContext);

	return (
		<div className="form__group">
			<label htmlFor="wtransactionStatusId" className="label">
				{t<string>("COMMON.STATUS")}
			</label>
			<select
				id="wtransactionStatusId"
				className="input input--med input--select"
				{...register("transactionStatusId")}
			>
				<option key="transactionStatus-all" value="all">
					{t<string>("COMMON.ALL_STATUS")}
				</option>
				{transactionStatuses?.map(
					(transactionStatus: { id: string; name: string }) => (
						<option
							key={transactionStatus.id}
							value={transactionStatus.id}
						>
							{transactionStatus.name}
						</option>
					)
				)}
			</select>
		</div>
	);
});
